import BaseService from '@/features/BaseService';

export default class LoadNotificationTypeService extends BaseService {
  constructor() {
    super('load-notification-types');
  }
}



// WEBPACK FOOTER //
// ./src/features/load-notification-type/LoadNotificationTypeService.js